import { TThunkAction } from '../../types/redux';
import { FDealType, dealTypeFromJsonQuery } from '../../utils/category';
import { setDefaultBackground } from './setDefaultBackground';

export const changeDefaultBackground = (): TThunkAction => {
  return (dispatch, getState, context) => {
    const {
      rentFlightRkData,
      showRentFlightRk,
      mainpage: { section },
      filters: { jsonQuery },
    } = getState();

    const dealType = dealTypeFromJsonQuery(jsonQuery);

    let defaultBackground;

    if (!!rentFlightRkData && (showRentFlightRk || dealType === FDealType.RentLongterm)) {
      defaultBackground = rentFlightRkData.background;
    } else {
      const imageUrlsBySection =
        context.config.get<Record<string, string>>('frontendMainPage.defaultImagesBySection') ?? {};

      defaultBackground = imageUrlsBySection[section];
    }

    if (defaultBackground) {
      dispatch(setDefaultBackground(defaultBackground));
    }
  };
};
